export const SIMPLE_VIEW = {
  label: 'Simple view',
  value: 'simple',
  isDetailView: false,
} as const;

export const DETAIL_VIEW = {
  label: 'Detail view',
  value: 'detail',
  isDetailView: true,
} as const;

export type TestStepsView = typeof SIMPLE_VIEW | typeof DETAIL_VIEW;
